import {authActions} from '@pages/auth/store/reducer';
import {dispatch} from '@store';
import axiosInstance, {
  AxiosError,
  InternalAxiosRequestConfig,
  AxiosResponse,
} from 'axios';

import BASE_URL from '../helpers/constants';
import STORAGE from '../helpers/storage-helpers/constants';
import StorageHelper from '../helpers/storage-helpers/storage.helper';
import {alertActions} from '../store/alertReducer';
import {API_CONSTANTS, coreActions} from '../store/loadingReducer';
import {flushStore} from '@core/store/flushStore';

const axios = axiosInstance.create({
  baseURL: BASE_URL,
});

export type API_KEYS = keyof typeof API_CONSTANTS;

export interface AxiosRequestConfigWithParams
  extends InternalAxiosRequestConfig {
  API?: API_KEYS;
  skipTopLoader?: boolean;
}

const handleTopLoader = (isLoading: boolean) => {
  dispatch(coreActions.handleIsLoading(isLoading));
};

axios?.interceptors.request.use(
  (config: AxiosRequestConfigWithParams) => {
    const accessToken = StorageHelper.getItem(STORAGE.ACCESS_TOKEN);
    if (config.headers && accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    if (!config.skipTopLoader) {
      handleTopLoader(true);
    }
    return config;
  },
  (error: AxiosError) => {
    dispatch(
      alertActions.setAlertMsg({
        code: error.code,
        message: error.message,
        alertType: 'danger',
      })
    );
    handleTopLoader(false);
    return Promise.reject(error);
  }
);

axios?.interceptors.response.use(
  (response: AxiosResponse) => {
    const config = response.config as AxiosRequestConfigWithParams;
    if (!config.skipTopLoader) {
      handleTopLoader(false);
    }
    return response;
  },
  (error) => {
    const config = error?.config as AxiosRequestConfigWithParams | undefined;
    let alertMsg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error.message;
    if (error?.response?.status === 500 || error?.response?.status === 502) {
      alertMsg = 'Server error. Please try again later.';
    }

    dispatch(
      alertActions.setAlertMsg({
        code: error.code,
        message: alertMsg,
        alertType: 'danger',
      })
    );
    if (error?.response?.status === 401) {
      if (!config?.skipTopLoader) {
        handleTopLoader(false);
      }
      dispatch(authActions.logout());
      flushStore();
      window.location.href = '/login';
      return Promise.reject(
        error instanceof Error ? error : new Error(alertMsg)
      );
    }
    if (error?.response?.status === 403) {
      if (!config?.skipTopLoader) {
        handleTopLoader(false);
      }
      dispatch(authActions.logout());
      flushStore();
      return Promise.reject(
        error instanceof Error ? error : new Error(alertMsg)
      );
    }
    if (!config?.skipTopLoader) {
      handleTopLoader(false);
    }
    if (error.response?.data) {
      // dispatch store for enabling modal
    }
    return Promise.reject(error instanceof Error ? error : new Error(alertMsg));
  }
);

export default axios;
